import type { TOC } from '@ember/component/template-only';
import Button from 'ui-kit/components/button';
import type { AttrValue } from '@glint/template';

interface S {
  Args: {
    title?: unknown;
    disabled?: AttrValue;
    onClick?: AttrValue;
  };
}

const CancelButton: TOC<S> = <template>
  <Button
    class='fluid form-button'
    type='button'
    onclick={{@onClick}}
    disabled={{@disabled}}
    data-test-cancel-button
  >
    {{if @title @title 'Retour'}}
  </Button>
</template>;

export default CancelButton;
